export default __webpack_public_path__ + "assets/component.b75cb848.svg";